import { render } from "./Order.vue?vue&type=template&id=04428312&scoped=true"
import script from "./Order.vue?vue&type=script&lang=ts"
export * from "./Order.vue?vue&type=script&lang=ts"

import "./Order.vue?vue&type=style&index=0&id=04428312&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04428312"

export default script